<app-simple-modal-header [pageTitle]="mode + ' ' + pageTitle"
                         (dismissed)="dismiss()"></app-simple-modal-header>

<ion-content>

     <ng-container *ngIf="mode=='Add'">
          <ion-label position="stacked">Select Form</ion-label>
          <ion-select placeholder="Select..." (ionChange)="onChangeWorkforceForm($event.detail.value)">
               <ion-select-option *ngFor="let form of addableWorkforceForms" [value]="form"> {{form.formName}}</ion-select-option>
          </ion-select>
     </ng-container>
     <form [formGroup]="formGroup" *ngIf="formGroup">
          <ion-list lines="full">

               <ion-item *ngFor="let fieldEntry of workforceForm?.entries">
                    <ion-label position="stacked" *ngIf="!(textBlockTypes.includes(fieldEntry.fieldTypeDescription))"> {{ fieldEntry.displayValue }} </ion-label>
                    <ion-checkbox *ngIf="fieldEntry.fieldTypeDescription=='CheckBox'" [formControl]="formGroup.controls[fieldEntry.id.toString()]"></ion-checkbox>
                    <ion-select *ngIf="selectTypes.includes(fieldEntry.fieldTypeDescription)"
                                placeholder="Select..."
                                [multiple]="fieldEntry.fieldTypeDescription=='ComboBoxCheckBox'"
                                [formControl]="formGroup.controls[fieldEntry.id.toString()]"
                                [value]="fieldEntry.value">

                         <ng-container *ngFor="let form of workforceForms">
                              <ng-container *ngFor="let field of form?.fields">

                                   <ng-container *ngFor="let lv of field?.listValues">
                                        <ion-select-option *ngIf="lv.formFieldId==fieldEntry.formFieldId"
                                                           [value]="lv.listValue">
                                             {{ lv.listValue }}
                                        </ion-select-option>
                                   </ng-container>
                              </ng-container>
                         </ng-container>

                    </ion-select>
                    <ion-textarea *ngIf="textAreaTypes.includes(fieldEntry.fieldTypeDescription)"
                                  placeholder="Enter text here..."
                                  [formControl]="formGroup.controls[fieldEntry.id.toString()]">

                    </ion-textarea>

                    <ion-label *ngIf="textBlockTypes.includes(fieldEntry.fieldTypeDescription)"
                                style="overflow:auto;white-space:pre-line;">
                         {{fieldEntry.value}}
                    </ion-label>

                    <ion-input *ngIf="dateTimeTypes.includes(fieldEntry.fieldTypeDescription)"
                               placeholder="Enter Date/Time..."
                               id="openCalendar{{fieldEntry.id}}"
                               [value]="fieldEntry.fieldTypeDescription=='Calendar' ?
									formGroup.controls[fieldEntry.id.toString()].value :
									formGroup.controls[fieldEntry.id.toString()].value"
                               readonly="true">
                         <ion-popover trigger="openCalendar{{fieldEntry.id}}" show-backdrop="true" id="popover-bottom">
                              <ng-template >
                                   <ion-datetime [presentation]="fieldEntry.fieldTypeDescription=='Calendar' ? 'date' : 'date-time'"
                                                 [formControl]="formGroup.controls[fieldEntry.id.toString()]"
                                                 (ionChange)="formGroup.controls[fieldEntry.id.toString()].setValue($event.target.value)">
                                   </ion-datetime>
                              </ng-template>
                         </ion-popover>
                    </ion-input>

                    <ion-img *ngIf="fieldEntry.fieldTypeDescription=='Signature' && fieldEntry.value?.length > 0" [src]="fieldEntry.value"></ion-img>
                    <ng-container *ngIf="fieldEntry.fieldTypeDescription=='Signature' && fieldEntry.value?.length === 0">
                         <signature-pad id="signaturePad" [options]="signaturePadOptions"></signature-pad>
                         <ion-button id="ionClear" (click)="signaturePad.clear()">Clear</ion-button>
                    </ng-container>
               </ion-item>





               <!--<ion-item>
                <ion-label position="stacked">Time Code:</ion-label>
                <ion-select
                 [formControl]="form.controls.timeCode"
                 [compareWith]="formHelper.compareWith"
                 [value]="form.controls.timeCode.value"
                >
                 <ion-select-option
                  *ngFor="let timeCode of timeCodeOptions"
                  [value]="timeCode"
                 >
                  {{ timeCode.desc }}
                 </ion-select-option>
                </ion-select>
               </ion-item>
               <ion-item>
                <ion-label position="stacked">Pay Code:</ion-label>
                <ion-select
                 [formControl]="form.controls.payCode"
                 [compareWith]="formHelper.compareWith"
                >
                 <ion-select-option
                  *ngFor="let payCode of payCodeOptions"
                  [value]="payCode"
                 >
                  {{ payCode.desc }}
                 </ion-select-option>
                </ion-select>
               </ion-item>
               <ion-item *ngIf="canShowServiceDropDown()">
                <ion-label position="stacked">Service:</ion-label>
                <ion-select
                 [formControl]="form.controls.service"
                 [compareWith]="formHelper.compareWith"
                 [value]="form.controls.service.value"
                >
                 <ion-select-option [value]="serviceOptionDefault">
                  {{ serviceOptionDefault.desc }}
                 </ion-select-option>
                 <ion-select-option
                  *ngFor="let service of serviceOptions"
                  [value]="service"
                 >
                  {{ service.desc }}
                 </ion-select-option>
                </ion-select>
               </ion-item>
               <ion-item>
                <ion-label position="stacked">Duration: (hh:mm)</ion-label>
                <ion-input id="open-time"
                     [value]="form.controls.time.value"
                     readonly="true"></ion-input>
                <ion-popover trigger="open-time" show-backdrop="true">
                 <ng-template>
                   <ion-datetime presentation="time" hourCycle="h23" [showDefaultButtons]="true"
                        [formControl]="form.controls.time">
                   </ion-datetime>
                 </ng-template>
                 </ion-popover>
               </ion-item>
               <ion-item>
                <ion-label position="stacked">Capital:</ion-label>
                <ion-select
                 placeholder="Select One"
                 [formControl]="form.controls.capital"
                >
                 <ion-select-option [value]="true">Yes</ion-select-option>
                 <ion-select-option [value]="false">No</ion-select-option>
                </ion-select>
               </ion-item>
               <ion-item>
                <ion-label position="stacked">Note</ion-label>
                <ion-textarea
                 [formControl]="form.controls.note"
                 name="note"
                 rows="4"
                ></ion-textarea>
               </ion-item>-->
          </ion-list>
     </form>
</ion-content>

<ion-footer>
     <ion-button expand="full"
                 class="modal__submit"
                 (click)="onClickWorkforceForm()">
          {{ mode === "Add" ? "Add" : "Save" }} Workforce Form
     </ion-button>
</ion-footer>
